// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infoContainerWrapper_TRX0j {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 0;
}

.infoContainer_tBGyV {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0;
  padding: 0;
  div {
    color: #1f184b;
    font-size: 12px;
    font-weight: 500;
  }
  span {
    max-width: 360px;
    color: #1f184b;
    font-size: 12px;
    font-weight: 300;
  }
}

.infoContainerFile_FTdGY {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0;
  padding: 0;
  margin: 0px;
  width: 100%;
}

.contentContainer_qFHTq {
  &.active_LZhll {
    display: block;
  }
  &.disabled_MiBP1 {
    display: none;
  }
}

.header_PleFz {
  display: flex;
  justify-content: space-between;
}

.headerMail_mnii7 {
  display: flex;
  align-items: center;
  justify-content: start;
  max-width: 200px;
  margin-top: 10px;
}

.iconContainer_gDppH {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--d9-background);
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  height: 27px;
  width: 30px;
}

.addConnection_PzXoi {
  color: #159b7c;
  cursor: pointer;
}

.labelFile_hW15N {
  color: #232222;
  cursor: pointer;
  border: 1px solid #cbcbcb;
  border-radius: 8px;
  padding: 5px 25px;
  font-size: 12px;
  font-weight: 500;
  margin: 0px;
}

.cssGmail_S9oRv {
  display: block;
  border: 1px solid #e5e5e5;
  padding: 15px 10px;
  border-radius: 15px;
}

.fileContainer_sKzBt {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  width: 100%;
}


`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/TelamatelFormAutomate/CustomNotify/CustomNotify.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,UAAU;EACV;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,MAAM;EACN,UAAU;EACV,WAAW;EACX,WAAW;AACb;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,WAAW;AACb","sourcesContent":[".infoContainerWrapper {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  padding: 0;\n}\n\n.infoContainer {\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0;\n  padding: 0;\n  div {\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 500;\n  }\n  span {\n    max-width: 360px;\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 300;\n  }\n}\n\n.infoContainerFile {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0;\n  padding: 0;\n  margin: 0px;\n  width: 100%;\n}\n\n.contentContainer {\n  &.active {\n    display: block;\n  }\n  &.disabled {\n    display: none;\n  }\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.headerMail {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  max-width: 200px;\n  margin-top: 10px;\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--d9-background);\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n  height: 27px;\n  width: 30px;\n}\n\n.addConnection {\n  color: #159b7c;\n  cursor: pointer;\n}\n\n.labelFile {\n  color: #232222;\n  cursor: pointer;\n  border: 1px solid #cbcbcb;\n  border-radius: 8px;\n  padding: 5px 25px;\n  font-size: 12px;\n  font-weight: 500;\n  margin: 0px;\n}\n\n.cssGmail {\n  display: block;\n  border: 1px solid #e5e5e5;\n  padding: 15px 10px;\n  border-radius: 15px;\n}\n\n.fileContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: space-between;\n  width: 100%;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoContainerWrapper": `infoContainerWrapper_TRX0j`,
	"infoContainer": `infoContainer_tBGyV`,
	"infoContainerFile": `infoContainerFile_FTdGY`,
	"contentContainer": `contentContainer_qFHTq`,
	"active": `active_LZhll`,
	"disabled": `disabled_MiBP1`,
	"header": `header_PleFz`,
	"headerMail": `headerMail_mnii7`,
	"iconContainer": `iconContainer_gDppH`,
	"addConnection": `addConnection_PzXoi`,
	"labelFile": `labelFile_hW15N`,
	"cssGmail": `cssGmail_S9oRv`,
	"fileContainer": `fileContainer_sKzBt`
};
export default ___CSS_LOADER_EXPORT___;
